import { useEffect, useState } from "react";
import { ToastContainer, toast, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast_config } from "../../../toastify/config";
import { useParams } from "react-router-dom";

import Swal from "sweetalert2";
import LoadingSpinner from "../../Blog/Spinner";
import apiSafibc from "../../../axios/axios";

import {
    Box,
    Button,
    Card,
    CardContent,
    LinearProgress,
    Typography
} from "@mui/material";

import { AnimatePresence, motion } from "motion/react";

import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";


const EncuestaExpo = () => {

    const [isLoading, setIsLoading] = useState(false)
    const [preguntas, setPreguntas] = useState([])
    const [respuestasPreguntas, setRespuestasPreguntas] = useState([])

    const [preguntaActual, setPreguntaActual] = useState(0);

    const [respuestasUsuario, setRespuestasUsuario] = useState({});

    const { ie } = useParams();

    const [encuestaTerminada, setEncuestaTerminada] = useState(false);
    const [estadoEncuesta, setEstadoEncuesta] = useState(null)


    const registrarIngreso = async () => {

        const ingresoRegistrado = localStorage.getItem(
            `encuesta_ingreso_${ie}`
        );

        // Ya se registró el ingreso anteriormente
        if (ingresoRegistrado) {
            return;
        }

        try {

            const apiKey = process.env.REACT_APP_AK_ENCUESTAEXPO;

            await apiSafibc.put("/registrar-ingreso-encuesta", { id_encuesta: ie },
                {
                    headers: {
                        "API-KEY": apiKey
                    }
                }
            );

            // Solo guardamos la marca si el endpoint respondió correctamente
            localStorage.setItem(
                `encuesta_ingreso_${ie}`,
                "true"
            );

        } catch (error) {
            console.log("Error al registrar ingreso:", error);

        }
    };

    const restaurarProgreso = () => {

        const progresoGuardado = localStorage.getItem(
            `encuesta_${ie}`
        );

        if (!progresoGuardado) {
            return;
        }

        try {

            const progreso = JSON.parse(progresoGuardado);

            if (progreso.terminada) {

                //setEncuestaTerminada(true);
                setEstadoEncuesta("terminada");
                return;
            }

            setPreguntaActual(progreso.preguntaActual);

        } catch (error) {

            console.log("Error al recuperar progreso:", error);

            localStorage.removeItem(`encuesta_${ie}`);
        }
    };

    const validarEncuesta = async () => {

        try {

            const apiKey = process.env.REACT_APP_AK_ENCUESTAEXPO;

            const { data } = await apiSafibc.get(`/validar-encuesta/${ie}`,
                {
                    headers: {
                        "API-KEY": apiKey,
                        "Accept": "*/*",
                    }
                }
            );

            if (!data.vigente) {

                // Eliminar el progreso guardado de ESTA encuesta
                localStorage.removeItem(`encuesta_${ie}`);

                //setEncuestaTerminada(true);
                setEstadoEncuesta("no_vigente");

                return;
            }

            // La encuesta sigue vigente
            restaurarProgreso();

        } catch (error) {

            console.log(error);

            toast.error(
                "No fue posible validar la encuesta.",
                toast_config
            );
        }
    };

    useEffect(() => {

        validarEncuesta();
        registrarIngreso()
    }, [ie]);


    const guardarProgreso = (preguntaActual, terminada) => {

        localStorage.setItem(
            `encuesta_${ie}`,
            JSON.stringify({
                preguntaActual,
                terminada
            })
        );

    };

    const responder = async (respuesta) => {

        try {

            const apiKey = process.env.REACT_APP_AK_ENCUESTAEXPO;

            const respuestaPregunta = {
                id_encuesta: ie,
                id_pregunta: pregunta.id_pregunta,
                respuesta: respuesta.no_respuesta
            }

            await apiSafibc.post("/guardar-respuesta-encuesta", respuestaPregunta,
                {
                    headers: {
                        "API-KEY": apiKey,
                    }
                }
            );

            setRespuestasUsuario(prev => ({
                ...prev,
                [pregunta.id_pregunta]: respuesta.id_respuesta
            }));

            if (preguntaActual < preguntas.length - 1) {
                const siguientePregunta = preguntaActual + 1;

                setPreguntaActual(siguientePregunta);

                guardarProgreso(
                    siguientePregunta,
                    false
                );
            } else {
                //setEncuestaTerminada(true);
                setEstadoEncuesta("terminada");

                guardarProgreso(
                    preguntaActual,
                    true
                );
            }

        } catch (error) {
            console.log(error)
            toast.error("No fue posible guardar la respuesta.", toast_config);
        }

    };

    const consultarPreguntasYrespuestas = () => {

        const consultar = async () => {

            try {

                setIsLoading(true)
                const apiKey = process.env.REACT_APP_AK_ENCUESTAEXPO;
                const listado = await apiSafibc.get('/preguntas-respuesta-encuesta', {
                    headers: {
                        'API-KEY': apiKey,
                        'Accept': '*/*',
                    }
                })

                setPreguntas(listado.data.preguntas)
                setRespuestasPreguntas(listado.data.respuestas)
                setIsLoading(false)

            } catch (error) {
                let msg_error = ''
                if (error.response) {
                    if (error.response.data.error) {
                        msg_error = error.response.data.error
                    } else {
                        msg_error = 'Ocurrió un error al generar encuesta, favor de volver a cargar!'
                    }
                }
                //mensaje de toastify
                toast.error(msg_error, toast_config)
                setIsLoading(false)
            }

        }

        consultar()

    }

    useEffect(() => {
        consultarPreguntasYrespuestas()
    }, [])

    const pregunta = preguntas[preguntaActual];

    const respuestas = respuestasPreguntas.filter(
        r => r.id_pregunta === pregunta?.id_pregunta
    );

    if (estadoEncuesta === "terminada" || estadoEncuesta === "no_vigente") {

        const encuestaNoVigente = estadoEncuesta === "no_vigente";

        return (
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    bgcolor: "#f5f5f5",
                    p: 2
                }}
            >
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: .5 }}
                >
                    <Card
                        sx={{
                            maxWidth: 600,
                            borderRadius: 4,
                            p: 4,
                            textAlign: "center"
                        }}
                    >

                        {!encuestaNoVigente && (
                            <CheckCircleOutline
                                color="success"
                                sx={{
                                    fontSize: 90,
                                    mb: 2
                                }}
                            />
                        )}

                        <Typography
                            variant="h4"
                            fontWeight="bold"
                            gutterBottom
                        >
                            {encuestaNoVigente
                                ? "Encuesta no disponible"
                                : "¡Muchas gracias!"
                            }
                        </Typography>

                        <Typography
                            variant="h6"
                            color="text.secondary"
                        >
                            {encuestaNoVigente
                                ? "Esta encuesta ya no se encuentra vigente."
                                : "Hemos recibido correctamente tus respuestas."
                            }
                        </Typography>

                        <Typography sx={{ mt: 2 }}>
                            {encuestaNoVigente
                                ? "El periodo para participar en esta encuesta ha finalizado."
                                : "Tu participación es muy importante para nosotros y nos ayudará a mejorar nuestros servicios."
                            }
                        </Typography>

                    </Card>
                </motion.div>
            </Box>
        );

    } else {
        return (
            <motion.div
                initial={{
                    opacity: 0,
                    y: 40,
                    scale: 0.98
                }}
                animate={{
                    opacity: 1,
                    y: 0,
                    scale: 1
                }}
                transition={{
                    duration: 0.6,
                    ease: "easeOut"
                }}
            >
                <Box
                    sx={{
                        minHeight: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        bgcolor: "#f5f5f5",
                        p: 2
                    }}
                >
                    {isLoading ?
                        <LoadingSpinner />
                        : null}
                    <Card
                        sx={{
                            width: "100%",
                            maxWidth: 650,
                            borderRadius: 4
                        }}
                    >

                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                pt: 4,
                                pb: 4
                            }}
                        >
                            <motion.img
                                src={'/img/logosafibc.png'}
                                alt="Logo"
                                initial={{ opacity: 0, scale: 0.8 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{
                                    delay: 0.2,
                                    duration: 0.5
                                }}
                                style={{
                                    width: "250px",
                                    maxWidth: "70%",
                                    height: "auto"
                                }}
                            />
                        </Box>

                        <LinearProgress
                            variant="determinate"
                            value={((preguntaActual + 1) / preguntas.length) * 100}
                        />

                        <CardContent>

                            <Typography
                                color="text.secondary"
                            >
                                Pregunta {preguntaActual + 1} de {preguntas.length}
                            </Typography>

                            <AnimatePresence mode="wait">

                                <motion.div

                                    key={preguntaActual}

                                    initial={{
                                        opacity: 0,
                                        x: 100
                                    }}

                                    animate={{
                                        opacity: 1,
                                        x: 0
                                    }}

                                    exit={{
                                        opacity: 0,
                                        x: -100
                                    }}

                                    transition={{
                                        duration: .3
                                    }}

                                >

                                    <Typography
                                        variant="h5"
                                        sx={{
                                            mt: 3,
                                            mb: 4,
                                            fontWeight: 600,
                                            textAlign: "center"
                                        }}
                                    >
                                        {pregunta?.pregunta}
                                    </Typography>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 2
                                        }}
                                    >

                                        {
                                            respuestas.map((respuesta) => (

                                                <Button

                                                    key={respuesta.id_respuesta}

                                                    variant="outlined"

                                                    size="large"

                                                    onClick={() => responder(respuesta)}

                                                    sx={{
                                                        py: 2,
                                                        fontSize: 18,
                                                        borderRadius: 3,
                                                        justifyContent: "center"
                                                    }}

                                                >
                                                    {respuesta.respuesta}
                                                </Button>

                                            ))
                                        }

                                    </Box>

                                </motion.div>

                            </AnimatePresence>

                        </CardContent>

                    </Card>

                </Box>

            </motion.div>

        )
    }




}


export default EncuestaExpo